// @ts-nocheck
import React from 'react'
import ReactAsyncSelect from 'react-select/async'
import ReactAsyncCreatableSelect from 'react-select/async-creatable'
import cx from 'classnames'
import { t } from 'ttag'

import { ClearIndicator } from './../ClearIndicator/ClearIndicator'
import { DropdownIndicator } from './../DropdownIndicator/DropdownIndicator'

import { useAsyncSelect } from './hooks'

import styles from './../../Combobox.module.scss'

export const AsyncSelect = React.forwardRef(
  (
    {
      error,
      id,
      name,
      noOptionsMessage = t`There're no options to choose`,
      placeholder,
      value,
      onBlur,
      onChange,
      filterOption,
      customComponents = [],
      transformData,
      styles: externalStyles,
      fetchOptions: [fetchFunc, matcher],
      closeMenuOnSelect = true,
      isClearable = true,
      isCreatable = false,
      isDisabled = false,
      isMulti = false,
      isReadOnly = false,
      isRequired = false,
      isSearchable = false,
    },
    ref,
  ) => {
    const { state, handlers } = useAsyncSelect(
      fetchFunc,
      matcher,
      transformData,
    )

    const { isFetching } = state
    const { loadOptions } = handlers

    const SelectComponent = isCreatable
      ? ReactAsyncCreatableSelect
      : ReactAsyncSelect

    return (
      <SelectComponent
        className={styles.combobox}
        classNames={{
          control: ({ isFocused }) =>
            cx(styles.control, {
              [styles.focus]: isFocused,
              [styles.disabled]: isDisabled,
              [styles.readOnly]: isReadOnly,
              [styles.invalid]: Boolean(error),
            }),
          input: () => styles.input,
          multiValue: () => styles.multiValue,
          placeholder: () => styles.placeholder,
          singleValue: () => styles.singleValue,
          multiValueRemove: () => styles.multiValueRemove,
          valueContainer: ({ isMulti, hasValue }) =>
            cx(styles.valueContainer, {
              [styles.multi]: isMulti && hasValue,
            }),
          menu: () => styles.menu,
          menuList: () => styles.menuList,
          option: ({ isSelected }) =>
            cx(styles.option, { [styles.selected]: isSelected }),
          noOptionsMessage: () => styles.noOptionsMessage,
        }}
        components={{
          ClearIndicator: ({ innerProps: { ref, ...props } }) => (
            <ClearIndicator {...{ ref, ...props }} />
          ),
          MultiValueRemove: ({ innerProps: { ref, ...props } }) => (
            <ClearIndicator {...{ ref, ...props }} />
          ),
          DropdownIndicator: () => <DropdownIndicator />,
          IndicatorSeparator: () => null,
          ...customComponents,
        }}
        isLoading={isFetching}
        required={isRequired}
        isClearable={isReadOnly ? false : isClearable}
        isSearchable={isReadOnly ? false : isSearchable}
        menuIsOpen={isReadOnly ? false : undefined}
        defaultOptions
        styles={externalStyles}
        {...{
          inputId: id,
          name,
          noOptionsMessage: () => noOptionsMessage,
          placeholder,
          ref,
          value,
          loadOptions,
          onBlur,
          onChange,
          isDisabled,
          isMulti,
          filterOption,
          closeMenuOnSelect,
          loadingMessage: () => t`Fetching options...`,
        }}
      />
    )
  },
)
